<div class="container">
    <div class="row mt-5">
        <div class="col-12 text-center">
            <h1>CrossTrend2 Backtest H1</h1>
        </div>
    </div>
    <div class="row mt-5">
        <div class="col-12 text-end">
            <div style="height: 400px; overflow-y: scroll;">
                <table class="table table-striped table-hover table-sm">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Market</th>
                            <th scope="col">Punti totali</th>
                            <th scope="col">Numero Operazioni</th>
                            <th scope="col">Punti per Operazione</th>
                            <th scope="col">% Positive</th>
                            <th scope="col">Rawal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of datiSummary; index as i">
                            <th scope="row">{{i+1}}</th>
                            <td>
                                <button type="button" class="btn btn-outline-primary btn-rounded btn-sm" mdbRipple
                                    (click)="caricaMercato(r)">
                                    {{r.market}}
                                </button>
                            </td>
                            <td>{{r.totale}}</td>
                            <td>{{r.numop}}</td>
                            <td>{{r.puntiop | number: '1.4-4'}}</td>
                            <td>{{(100*r.percpos) | number: '1.2-2'}} %</td>
                            <td>{{r.rawal | number: '1.2-2'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
<div class="row mt-5">
    <div class="col-12">
        <highcharts-chart [Highcharts]="Highcharts" [constructorType]="chartConstructor" [options]="chartOptions"
            [(update)]="updateFlag" [oneToOne]="oneToOneFlag" [runOutsideAngular]="runOutsideAngularFlag"
            style="width: 100%; height: 600px; display: block;"></highcharts-chart>
    </div>
</div>
<div class="row mt-5">
    <div class="col-6 text-center" *ngIf="datiTrading.length>0">
        <app-trading-system-summary [ts]="tsSummary"></app-trading-system-summary>
    </div>
    <div class="col-6">
        <app-trading-system-grafico-weekly #chartWeek
            [titolo]="'Trading System Weekly'"></app-trading-system-grafico-weekly>
    </div>
</div>

<div class="row mt-5">
    <div class="col-6">
        <app-trading-system-grafico-weekly #chartBuy
            [titolo]="'Trading System Weekly Buy'"></app-trading-system-grafico-weekly>
    </div>
    <div class="col-6">
        <app-trading-system-grafico-weekly #chartSell
            [titolo]="'Trading System Weekly Sell'"></app-trading-system-grafico-weekly>
    </div>
</div>
<div class="row mt-5">
    <div class="col-12">
        <app-trading-system-grafico-weekly #chartMonth
            [titolo]="'Trading System Monthly'"></app-trading-system-grafico-weekly>
    </div>
</div>

<div class="row mt-5">
    <div class="col-6">
        <app-trading-system-grafico-weekly #chartMonthlyBuy
            [titolo]="'Trading System Monthly Buy'"></app-trading-system-grafico-weekly>
    </div>
    <div class="col-6">
        <app-trading-system-grafico-weekly #chartMonthlySell
            [titolo]="'Trading System Monthly Sell'"></app-trading-system-grafico-weekly>
    </div>
</div>